import { Injectable } from "@angular/core";
import { Concessao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity";
import { AitTaxiDTO, AitTaxiDTOList } from "app/model/dtos/mob/ait-taxi.dto";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environmentv3 } from "src/environments/environmentv3";
import { ApiController } from "../api-controller.interface";

@Injectable()
export class AitTaxiController implements ApiController<AitTaxiDTO>{

    find(filters?: IFilter): Promise<AitTaxiDTO[]> {
        throw new Error("Method not implemented.");
    }

    findAits(filters?: IFilter): Promise<AitTaxiDTOList> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/ait/taxi',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new AitTaxiDTOList())
        );
        return request.call();
    }

    get(id: number): Promise<AitTaxiDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/ait/taxi/:cdAit',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdAit: id
                    }),
                }),
            }),
            new HttpResponse(new AitTaxiDTO())
        );
        return request.call();
    }

    create(entity: AitTaxiDTO): Promise<AitTaxiDTO> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/ait/taxi',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new AitTaxiDTO()
            )
        );
        return request.call();
    }

    update(entity: AitTaxiDTO): Promise<AitTaxiDTO> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/ait/taxi/:cdAit',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdAit: entity.cdAit
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new AitTaxiDTO()
            )
        );
        return request.call();
    }


    findPermissionario(filtros?: IFilter): Promise<Concessao> {
        let quark = new Quark(
          new HttpGet({
            url: new Url({
              id: 'mob/ait/taxi/concessao',
              environment: environmentv3,
              filter: filtros
            }),
          }),
          new HttpResponse(new Concessao())
        );
        return quark.call();
      }
}